"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const EPaymentMethod_1 = require("../../enums/ProductSubscribed/EPaymentMethod");
const consortiumCredit_1 = require("../../utils/consortiumCredit");
const CustomAsync_1 = __importDefault(require("../decorators/CustomAsync"));
const Di_1 = __importDefault(require("../injectables/Di"));
const Resource_1 = __importDefault(require("../Resource"));
const ValidationErrors_1 = require("../../enums/Validation/ValidationErrors");
class UpdatePaymentMethodRequestResource extends Resource_1.default {
}
exports.default = UpdatePaymentMethodRequestResource;
__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.IsUUID)(),
    (0, class_transformer_1.Expose)(),
    (0, CustomAsync_1.default)((id) => Di_1.default.getProductSubscribedService().exists(id), {
        message: ValidationErrors_1.EValidationError.productSubscribedNotExists,
    }),
    __metadata("design:type", String)
], UpdatePaymentMethodRequestResource.prototype, "productSubscribedId", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(EPaymentMethod_1.EPaymentMethod),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], UpdatePaymentMethodRequestResource.prototype, "paymentMethod", void 0);
__decorate([
    (0, class_validator_1.MaxLength)(60, { context: [60] }),
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.ValidateIf)((obj) => {
        if (obj.paymentMethod !== EPaymentMethod_1.EPaymentMethod.PRELEVEMENT)
            obj.titularyName = null;
        return obj.paymentMethod === EPaymentMethod_1.EPaymentMethod.PRELEVEMENT;
    }),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], UpdatePaymentMethodRequestResource.prototype, "titularyName", void 0);
__decorate([
    (0, class_validator_1.MaxLength)(120, { context: [120] }),
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.ValidateIf)((obj) => {
        if (obj.paymentMethod !== EPaymentMethod_1.EPaymentMethod.PRELEVEMENT)
            obj.bankDomiciliation = null;
        return obj.paymentMethod === EPaymentMethod_1.EPaymentMethod.PRELEVEMENT;
    }),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], UpdatePaymentMethodRequestResource.prototype, "bankDomiciliation", void 0);
__decorate([
    (0, class_validator_1.MaxLength)(34, { context: [34] }),
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.ValidateIf)((obj) => {
        if (obj.paymentMethod !== EPaymentMethod_1.EPaymentMethod.PRELEVEMENT)
            obj.iban = null;
        return obj.paymentMethod === EPaymentMethod_1.EPaymentMethod.PRELEVEMENT;
    }),
    (0, class_validator_1.IsIBAN)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], UpdatePaymentMethodRequestResource.prototype, "iban", void 0);
__decorate([
    (0, class_validator_1.MaxLength)(11, { context: [11] }),
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.ValidateIf)((obj) => {
        if (obj.paymentMethod !== EPaymentMethod_1.EPaymentMethod.PRELEVEMENT)
            obj.bic = null;
        return obj.paymentMethod === EPaymentMethod_1.EPaymentMethod.PRELEVEMENT;
    }),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], UpdatePaymentMethodRequestResource.prototype, "bic", void 0);
__decorate([
    (0, class_validator_1.MaxLength)(60, { context: [60] }),
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.ValidateBy)({
        name: "consortiumLender",
        validator: {
            validate: (value, arguments_) => arguments_.object.paymentMethod !== EPaymentMethod_1.EPaymentMethod.CREDIT_CONSORTIUM || (0, consortiumCredit_1.isConsortiumLender)(value),
            defaultMessage: () => "L'organisme du crédit Consortium doit être CFCAL ou CACF.",
        },
    }),
    (0, class_validator_1.ValidateIf)((obj) => {
        if (!(0, consortiumCredit_1.isCreditPaymentMethod)(obj.paymentMethod))
            obj.organismName = null;
        return (0, consortiumCredit_1.isCreditPaymentMethod)(obj.paymentMethod);
    }),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], UpdatePaymentMethodRequestResource.prototype, "organismName", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.ValidateIf)((obj) => {
        if (!(0, consortiumCredit_1.isCreditPaymentMethod)(obj.paymentMethod))
            obj.nantieParts = null;
        return (0, consortiumCredit_1.isCreditPaymentMethod)(obj.paymentMethod);
    }),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], UpdatePaymentMethodRequestResource.prototype, "nantieParts", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.Min)(0, { context: [0] }),
    (0, class_validator_1.ValidateIf)((obj) => {
        if (!(0, consortiumCredit_1.isCreditPaymentMethod)(obj.paymentMethod))
            obj.loanAmount = null;
        return (0, consortiumCredit_1.isCreditPaymentMethod)(obj.paymentMethod);
    }),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], UpdatePaymentMethodRequestResource.prototype, "loanAmount", void 0);
